/** Web resolution of `./index`. See that file's header. */

export type {
  PickMessageFiles,
  PickSource,
  StageInlineImageFile,
} from './messageFilePicker';
export type { StagedFile } from './stagedFile';
export {
  FALLBACK_MIME_TYPE,
  isPreviewableImage,
  nextStagedFileId,
  toStagedFile,
} from './stagedFile';
export {
  MAX_RAW_PAYLOAD_CHARS_PER_FILE,
  decodedBase64ByteLength,
  stripDataUriPrefix,
} from './messageFileBytes';

export { pickMessageFiles } from './messageFilePicker.web';
export { webPickerSources as pickerSources } from './messageFilePicker.web';
export { stageInlineImageFile } from './messageFilePicker.web';
